import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-remarks',
  templateUrl: './remarks.component.html',
  styleUrls: ['./remarks.component.css'],
})
export class RemarksComponent implements OnInit {
  private HistoryApi = environment.url + 'coe/history?id=';
  datas;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    private makeapi: ApiService,
    public dialogRef: MatDialogRef<RemarksComponent>
  ) {
    this.datas = data;
  }
  isCoeRoute = this.router.url.includes('coe-list');
  ngOnInit(): void {
    if (this.isCoeRoute) {
      this.HistoryModal();
    }
  }
  historyData;
  noData = false;
  apiData: any;
  /**
   * Fetches the history of the application from the API using the application ID provided in the dialog data.
   * Updates the component's data on success.
   */
  HistoryModal() {
    let id = this.datas._applicationId;
    return this.makeapi
      .method(this.HistoryApi + id, '', 'get')
      .subscribe((data) => {
        this.apiData = data;
        if (data.coeAppHistory) {
          // If the response contains history data, set noData to false and update the component's historyData.
          this.noData = false;
          this.historyData = data.coeAppHistory;
        } else {
          // If no history data is found, set noData to true.
          this.noData = true;
        }
      });
  }
  cancelReason() {
    this.dialogRef.close();
  }
}
